import * as React from 'react';
import styled from 'styled-components';
import { AdDimension } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import { GooglePublisherTag } from './GooglePublisherTag';
import { DEFAULT_AD_DIMENSIONS } from './utils';

const GOOGLE_AD_CHANNEL = getPublicRuntimeConfig('GOOGLE_AD_CHANNEL');

export const GoogleAdsWrapper = styled.div<{ maxWidth: string }>`
  margin: 0 auto;
  max-width: ${({ maxWidth }) => maxWidth};
`;

export type GoogleAdProps = {
  adUnitPath?: string;
  sizes?: AdDimension[];
  maxWidth: string;
  enableSingleRequest: boolean;
};

export const GoogleAds: React.FC<GoogleAdProps> = ({
  enableSingleRequest = true,
  adUnitPath,
  sizes = DEFAULT_AD_DIMENSIONS,
  maxWidth,
}) => {
  return (
    <GoogleAdsWrapper maxWidth={maxWidth} data-testid="google-ads-wrapper">
      <GooglePublisherTag
        enableSingleRequest={enableSingleRequest}
        path={adUnitPath || GOOGLE_AD_CHANNEL}
        dimensions={sizes}
      />
    </GoogleAdsWrapper>
  );
};
